import axios from "./axios-wrapper";
import dayjs from "dayjs";

export const getTokenSnapshot = async (
    token,
    params = {
        from: dayjs().subtract(6, "months"),
        to: dayjs(),
        networks: [],
    }
) => {

    const from_timestamp = params.from.unix();
    const to_timestamp = params.to.unix();

    let url = `/history/token-snapshots/${token}?from_timestamp=${from_timestamp}&to_timestamp=${to_timestamp}`

    if (params.networks.length > 0) {
        url += `&networks=${params.networks.join(",")}`;
    }

    const response = await axios.get(url);
    return response.data;
}
